<script setup lang="ts">
import Markdown from "@/core/components/markdown/Markdown.vue";
import ExpandableTextOverflow from "@/core/components/expandable-text-overflow/ExpandableTextOverflow.vue";
import videoThumbnail from "@/assets/images/turorial-thumbnail.png";
import {ref} from "vue";
import BaseModal from "@/core/components/base/BaseModal.vue";
import EmbedVideo from "@/core/components/video/EmbedVideo.vue";

defineProps<{ description: string; duration?: number; videoUrl?: string }>();

const visible = ref(false);
</script>

<template>
  <div class="bg-gray-100 rounded-t-md flex flex-wrap justify-between gap-10 py-4">
    <div class="flex flex-1 flex-col flex-wrap border-l-[5px] border-primary pl-2">
      <div class="flex flex-row pr-2 justify-between items-center">
        <h2 class="text-black">
          🎯 Objectif
        </h2>
        <span v-if="duration" class="text-sm">Durée : {{ duration }}min</span>
      </div>
      <expandable-text-overflow size="small" :background-color="{red: 243, green: 244, blue: 246}">
        <markdown :content="description" class="pl-0" />
      </expandable-text-overflow>
    </div>
    <div v-if="videoUrl" class="w-44 pl-4">
      <img :src="videoThumbnail" class="object-contain hover:opacity-75 cursor-pointer" @click="visible = true">
      <base-modal v-if="visible" title=" " @close="visible = false">
        <embed-video :url="videoUrl" class="w-full" />
      </base-modal>
    </div>
  </div>
</template>
